<template>
    <div>

        <v-form v-model="valid" ref="formData">
            <v-overlay :value="overlay">
                <v-progress-circular indeterminate size="64"></v-progress-circular>
            </v-overlay>

            <v-card>
                <v-card-title>
                    <span class="headline" v-if="toggleAdd">{{ $t("payment") }}</span>
                    <span class="headline" v-if="!toggleAdd">{{ $t("payment") }}</span>
                    <v-spacer></v-spacer>
                    <v-btn
                        fab
                        text
                        icon
                        @click="handleClose"
                        valid="false"
                        v-shortkey="['esc']"
                        @shortkey.native="handleClose"
                    >
                        <v-icon dark>mdi-close</v-icon>
                    </v-btn>
                </v-card-title>

                <v-card-text>
                    <v-row>
                        <v-col cols="12" sm="6" md="6" class="seperate-line-verticle">
                            <v-row>
                                <v-col cols="12" sm="12" md="12">
                                    <v-text-field
                                        dense
                                        disabled
                                        outlined
                                        v-model="formDoc.supplier"
                                        :label="$t('supplier') + '*'"
                                    ></v-text-field>
                                </v-col>

                                <v-col cols="12" sm="12" md="12">
                                    <v-text-field
                                        dense
                                        outlined
                                        disabled
                                        v-model="formDoc.client"
                                        :label="$t('client') + '*'"
                                    ></v-text-field>
                                </v-col>

                                <v-col cols="12" sm="12" md="12">
                                    <v-select
                                        :items="currencyOptionList"
                                        :label="$t('currency') + '*'"
                                        outlined
                                        v-model="formDoc.currency_code"
                                        disabled
                                        item-text="text"
                                        item-value="id"
                                        dense
                                    ></v-select>
                                </v-col>

                                <v-col cols="12" sm="12" md="12" v-if="formDoc.payment_method==='cash'">
                                    <v-select
                                        :items="customerWallet"
                                        :label="$t('wallet') + '*'"
                                        outlined
                                        v-model="formDoc.wallet_account"
                                        :rules="selectRules"
                                        item-text="account_type_name"
                                        item-value="account_type_name"
                                        dense
                                    >
                                        <template v-slot:selection="{item}">
                                            {{$t(item.account_type_name) }} : {{ item.available_balance |
                                            formatNumber}} {{currency_symbol}}
                                        </template>
                                        <template v-slot:item="{item}">
                                            {{ $t(item.account_type_name) }} : {{ item.available_balance |
                                            formatNumber}} {{currency_symbol}}
                                        </template>
                                    </v-select>
                                </v-col>

                                <v-col cols="12" sm="12" md="12">
                                    <v-menu
                                        v-model="menuDate"
                                        :close-on-content-click="false"
                                        :nudge-right="40"
                                        transition="scale-transition"
                                        offset-y
                                        min-width="290px"
                                    >
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-text-field
                                                v-model="formDoc.date"
                                                :label="$t('receivePaymentDate') + '*'"
                                                prepend-inner-icon="mdi-calendar"
                                                outlined
                                                dense
                                                readonly
                                                :rules="dateRules"
                                                v-bind="attrs"
                                                v-on="on"
                                            ></v-text-field>
                                        </template>
                                        <v-date-picker
                                            :first-day-of-week="0"
                                            v-model="formDoc.date"
                                            :rules="dateRules"
                                            @input="menuDate = false"
                                        ></v-date-picker>
                                    </v-menu>
                                </v-col>

                                <v-col cols="12" sm="12" md="12">
                                    <v-text-field
                                        outlined
                                        dense
                                        v-model="formDoc.reference"
                                        :label="$t('reference')"
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                        </v-col>

                        <v-col cols="12" sm="6" md="6">
                            <v-row>
                                <v-col cols="5" sm="5">{{ $t("step") }}</v-col>
                                <v-col cols="7" sm="7"> : <span style="font-weight: bold;font-size: 20px">{{ formDoc.step}}</span></v-col>
                                <v-col cols="5" sm="5">{{ $t("duration") }}</v-col>
                                <v-col cols="7" sm="7"> : <span style="font-weight: bold;font-size: 20px">{{ formDoc.duration }} {{ $t(formDoc.duration_type.split("_")[1])}}</span></v-col>
                                <v-col cols="5" sm="5">{{ $t("totalAmount") }}</v-col>
                                <v-col cols="7" sm="7"> : <span style="font-weight: bold;font-size: 20px">{{ formDoc.total_payment | formatNumber }}{{currency_symbol}}</span></v-col>
                                <v-col cols="5" sm="5">{{ $t("percentage") }}</v-col>
                                <v-col cols="7" sm="7"> : <span style="font-weight: bold;font-size: 20px">{{ formDoc.percentage}}%</span></v-col>
                                <v-col cols="5" sm="5">{{ $t("paidAmount") }}</v-col>
                                <v-col cols="7" sm="7">
                                    <v-text-field
                                        v-model="formDoc.paid_amount"
                                        outlined
                                        dense
                                        :max="formDoc.total_payment"
                                        min="1"
                                        style="margin-bottom: -10px"
                                        required
                                        :rules="requireAndNumberAtleaseOne"
                                        @input="typePaidAmount()"
                                        >
                                        </v-text-field>
                                    <span v-show="walletMessage" class="error--text">{{ walletMessage }}</span>
                                </v-col>

                                <v-col cols="12" sm="12" md="12">
                                    <v-textarea
                                        clearable
                                        outlined
                                        :placeholder="$t('yourDesc')"
                                        v-model="formDoc.note"
                                        clear-icon="mdi-close-circle"
                                        rows="3"
                                        auto-grow
                                        :label="$t('note')"
                                    ></v-textarea>
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        rounded
                        @click="submit($event,true)"
                        style="min-width: 150px"
                        color="primary"
                    >
                        <font-awesome-icon icon="check-circle" class="mr-2"/>
                        {{$t("payAndPrint")}}
                    </v-btn>

                    <v-btn
                        rounded
                        @click="submit($event)"
                        style="min-width: 150px"
                        color="success"
                    >
                        <font-awesome-icon icon="check-circle" class="mr-2"/>
                        {{$t("proceedPay")}}

                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-form>

    </div>
</template>
<script>

    import OptionDataMixin from "../../../mixins/optionDataMixin";
    import MainMixin from "../../../mixins/mainMixin";
    import ValidatorMixin from "../../../mixins/validatorMixin";
    import moment from "moment";
    import {provider} from "@/service/provider";
    import axios from "axios";

    export default {
        mixins: [OptionDataMixin, MainMixin, ValidatorMixin],
        components: {},
        props: ["paymentDoc", "isEdit","type"],
        name: "createReceivePayment",
        data() {
            return {
                walletMessage: '',
                checkAll: false,
                dialogDetail: false,
                detailDoc: {},
                overlay: false,
                page: 1,
                formDoc: {
                    transaction_id: "",
                    reference: "",
                    date: "",
                    client_id: "",
                    supplier_id: "",
                    client: "",
                    supplier: "",
                    total_payment: "",
                    transaction_payment_term_id: "",
                    due_date: "",
                    step: "",
                    duration_type: "",
                    percentage: "",
                    paid_amount: "",
                    due_payment: "",
                    currency_code: "",
                    duration: "",
                    client_account_no: "",
                    client_phone: "",
                    supplier_phone: "",
                    wallet_account: ""

                },
                transaction_line: [
                    // {variation_id: "", name: "Rice", qty: 10, price: 5000, amount: 50000.3345},
                ],
                transaction_line_header: [
                    {
                        text: "productName",
                        align: "start",
                        sortable: false,
                        value: "name"
                    },
                    {text: "price", value: "price", sortable: false},
                    {text: "qty", value: "qty", width: 150, sortable: false},
                    {text: "amount", value: "sub_total", sortable: false},
                ],
                supplierDoc: {},
                currency_symbol: "",
                totalInWallet: 0
            };
        },
        methods: {
            typePaidAmount(){
                this.walletMessage = '';
            },  
            handleCreateReceivePayment(doc) {
                let vm = this;
                if (this.isEdit === false) {
                    vm.toggleAdd = true;
                    vm.formDoc = doc;
                    vm.formDoc.payment_method = "cash";
                    vm.formDoc.paid_amount = parseFloat(vm.formDoc.due_payment);
                    vm.formDoc.date = moment().format("YYYY-MM-DD");
                    vm.formDoc.id = "";
                    vm.formDoc.reference = "";
                    vm.formDoc.paid_amount=parseFloat(vm.formDoc.total_payment);
                    // vm.formDoc.wallet_account = vm.formDoc.paid_amount;
                } else {
                    vm.toggleAdd = false;
                    vm.formDoc = doc;
                }
                vm.$nextTick(() => {
                    console.log(vm.formDoc.payment_method)
                    vm.calculateTotal();
                    vm.getWallet();
                });
            },
            handleClose() {
                let vm = this;
                vm.$emit("handleCloseReceivePayment", {payment_transaction_id: ""});
            },
            handleCloseWhenSubmit(id) {
                let vm = this;
                vm.$emit("handleCloseReceivePayment", {payment_transaction_id: id || ""});
            },
            submit(event, isPrint) {
                let vm = this;
                event.preventDefault();
                if (vm.$refs.formData.validate()) {
                    /**
                     * Check in wallet
                     */
                    // let walletType  = vm.customerWallet.find(o => o.account_type_name === vm.formDoc.wallet_account);
                    // let inWallet = walletType ? walletType.available_balance : 0;
                    
                    // if((+inWallet >= +vm.formDoc.total_payment) && (+vm.formDoc.paid_amount > 0 )){
                    //     if(+vm.formDoc.paid_amount <= +vm.formDoc.total_payment){
                            vm.walletMessage = '';
                            vm.overlay = true;
                            vm.formDoc.user_id = localStorage.id;
                            vm.formDoc.note = vm.formDoc.note || "";
                            let newFormDoc = Object.assign({}, vm.formDoc);
                            newFormDoc.date = vm.parseToDate(vm.formDoc.date);
                            let url = provider.baseURL + provider.storePaymentTerm;
                            return new Promise((resolve, reject) => {
                                axios.post(url, newFormDoc, {headers: {Authorization: localStorage.token}}).then(
                                    res => {
                                        if (res.data.response && res.data.response.code === 200) {
                                            resolve(res.data.data.payment_transaction_id);
                                            vm.$notify({
                                                title: "Success",
                                                message: vm.$t("success"),
                                                type: "success",
                                                duration: 700
                                            });
                                            vm.dialog = false;
                                            vm.handleCloseWhenSubmit(res.data.data.payment_transaction_id);
                                            if (isPrint === true) {
                                                if(vm.type==="take-out" || vm.type==="farmer"){
                                                    vm.$router.push({name: 'beeshop.agri-input.order-farmer-management.print-invoice-farmer', params: { id: res.data.data.invoice_transaction_id}})
                                                }else {
                                                    vm.$router.push({name: 'beeshop.agri-input.order-farmer-management.print-invoice-farmer', params: { id: res.data.data.invoice_transaction_id,type:"sale_order"}})
    
                                                }
                                            }
                                            vm.overlay = false;
    
                                        }
                                    },
                                    error => {
                                        reject(error);
                                        vm.overlay = false;
    
                                    }
                                );
                            });
                    //     }
                    //     else{
                    //         vm.walletMessage = vm.$t('paidAmountLess') + vm.formDoc.total_payment;
                    //     }
                    // }
                    // else{
                    //     vm.walletMessage = vm.$t('walletNotEnough');
                    // }
                }
            },
            calculateTotal() {
                let vm = this;
                let walletDoc = vm.customerWallet.find(o => o.account_type_name === vm.formDoc.wallet_account);
                if (walletDoc) {
                    vm.totalInWallet = parseFloat(walletDoc.available_balance);
                } else {
                    vm.totalInWallet = 0;
                }

            },
            getWallet() {
                let vm = this;
                vm.fetchWalletByCustomer(vm.formDoc.client_account_no, vm.formDoc.currency_code);
            }
        },
        watch: {
            "formDoc.wallet_account"() {
                let vm = this;
                vm.walletMessage = '';
                vm.calculateTotal();
            },
            "formDoc.currency_code"(val) {
                let vm = this;
                vm.currency_symbol = vm.getCurrencySymbol(val);
            },
        },
        computed: {
            userDoc() {
                return this.$store.state.userDoc;
            },
            balance() {
                return (this.formDoc.total_amount || 0) - (this.formDoc.paid_amount || 0)
            }
        },
        created() {
            let vm = this;
            if(this.paymentDoc.client_type == 'farmer' && this.paymentDoc.payment_method == 'cash'){
                this.paymentDoc.client_account_no = this.paymentDoc.supplier_account_no;
            }

            vm.handleCreateReceivePayment(this.paymentDoc);
            vm.fetchCurrencyOption();
            vm.formDoc.duration_period = "per_month";

            let url = provider.baseURL + provider.getListSupplier;
            return new Promise((resolve, reject) => {
                axios.post(url, {
                    id: this.paymentDoc.supplier_id,
                    search: "",
                    parent_id: "",
                    client_type: "",
                    offset: 0,
                    limit: 1,
                }, {headers: {Authorization: localStorage.token}}).then(
                    res => {
                        if (res.data.response && res.data.response.code === 200) {
                            resolve(res.data.data);
                            vm.supplierDoc = res.data.data && res.data.data[0] || {};
                        }
                    },
                    error => {
                        reject(error);
                    }
                );
            });
        }
    };
</script>
